module.exports = __webpack_public_path__ + "static/media/chatbubbles-outline.ad64cfb9.svg";